module.exports = require('./helpers/bundle-url').getBundleURL('13ph5') + "gameofur.fb4d886d.webp";